import React, { useState, useContext } from 'react'
import { UserContext } from 'stores/UserStore'
import tlh from 'api/tlh'
import { decompressResponse } from 'utils/decompress'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

export const TubularContext = React.createContext({})

export const TubularProvider = ({ children }) => {
    const { t } = useTranslation()

    const { idToken } = useContext(UserContext)
    const [isLoading, setLoading] = useState(false)
    const [searchResult, setSearchResult] = useState(0)
    const [invoiceResult, setInvoiceResult] = useState([])
    const [reservationResult, setReservationResult] = useState([])
    const [ippnResult, setIppnResult] = useState([])
    const [sotResult, setSotResult] = useState([])
    const [purchaseOrderResult, setPurchaseOrderResult] = useState([])
    const [salesOrderResult, setSalesOrderResult] = useState([])
    const [searchIppnResults, setSearchIppnResults] = useState([])
    const [searchInvoiceResults, setSearchInvoiceResults] = useState([])
    const [searchSotResults, setSearchSotResults] = useState([])
    const [searchPurchaseOrderResults, setSearchPuchaseOrderResults] = useState([])
    const [searchSalesOrderResults, setSearchSalesOrderResults] = useState([])
    const [searchReservationResults, setSearchReservationResults] = useState([])
    const [customersId, setCustomersId] = useState([])
    // const [client, setClient] = useState([])

    const [valueData, setValueData] = useState()
    const [searchValue, setSearchValue] = useState()

    const [sotId, setSotId] = useState('')
    const [ippnId, setIppnId] = useState('')
    const [validId, setValidId] = useState(null)
    const [invoiceId, setInvoiceId] = useState('')
    const [purchaseId, setPurchaseId] = useState('')
    const [reservationId, setReservationId] = useState('')

    const noData = () => {
        toast(t('tlh.noData'))
    }

    const checkHasData = (data) => {
        if (data > 0) {
            return true
        } else {
            setValueData('')
            toast(t('tlh.noData'))
            return false
        }
    }

    const getInvoiceSearchData = (value) => {
        setSearchResult(0)
        setLoading(true)
        return tlh.getInvoiceData(idToken, value).then(data => {
            data = data.body ? data.body : data
            const descompressData = decompressResponse(data)
            if (descompressData) {
                if (checkHasData(descompressData.total)) {
                    setSearchResult(descompressData.total)
                    if (descompressData.total === 1) {
                        setInvoiceResult(descompressData)
                        setValueData(descompressData.invoice)
                    } else {
                        setSearchInvoiceResults(descompressData.invoice)
                    }
                }
            } else {
                setInvoiceResult([])
                setValueData([])
                setSearchInvoiceResults([])
            }
            setLoading(false)
        }).catch(error => {
            if (error.message.indexOf("503") > 1) {
                toast(t('tlh.refineSearch'))
            } else {
                noData()
            }
            setLoading(false)
        })
    }

    const getReservationSearchData = (value) => {
        setSearchResult(0)
        setLoading(true)
        return tlh.getReservationData(idToken, value).then(data => {
            data = data.body ? data.body : data
            const descompressData = decompressResponse(data)
            if (checkHasData(descompressData.total)) {
                setSearchResult(descompressData.total)
                if (descompressData.total === 1) {
                    setValueData(descompressData.reservation)
                    setReservationResult(descompressData)
                } else {
                    setSearchReservationResults(descompressData.reservation)
                }
            } else {
                setValueData([])
                setReservationResult([])
                setSearchReservationResults([])
            }
            setLoading(false)
        }).catch(error => {
            if (error.message.indexOf("503") > 1) {
                toast(t('tlh.refineSearch'))
            } else {
                noData()
            }
            setLoading(false)
        })
    }
    const getPurchaseOrderSearchData = (value) => {
        setSearchResult(0)
        setLoading(true)
        return tlh.getPurchaseOrderData(idToken, value).then(data => {
            data = data.body ? data.body : data
            const descompressData = decompressResponse(data)
            console.log(descompressData)
            if (checkHasData(descompressData.total)) {
                setSearchResult(descompressData.total)
                if (descompressData.total === 1) {
                    setValueData(descompressData.purchase)
                    setPurchaseOrderResult(descompressData)
                } else {
                    setSearchPuchaseOrderResults(descompressData.purchases)
                }
            } else {
                setPurchaseOrderResult([])
                setValueData([])
                setSearchPuchaseOrderResults([])
            }
            setLoading(false)
        }).catch(error => {
            if (error.message.indexOf("503") > 1) {
                toast(t('tlh.refineSearch'))
            } else {
                noData()
            }
            setLoading(false)
        })
    }

    const getSalesOrderSearchData = (value) => {
        setSearchResult(0)
        setLoading(true)
        return tlh.getSalesOrderData(idToken, value).then(data => {
            data = data.body ? data.body : data
            const descompressData = decompressResponse(data)
            console.log(descompressData)
            if (checkHasData(descompressData.total)) {
                setSearchResult(descompressData.total)
                if (descompressData.total === 1) {
                    setValueData(descompressData.salesOrder)
                    setSalesOrderResult(descompressData)
                } else {
                    setSearchSalesOrderResults(descompressData.sales)
                }
            } else {
                setSalesOrderResult([])
                setValueData([])
                setSearchSalesOrderResults([])
            }
            setLoading(false)
        }).catch(error => {
            if (error.message.indexOf("503") > 1) {
                toast(t('tlh.refineSearch'))
            } else {
                noData()
            }
            setLoading(false)
        })
    }

    const getIppnSearchData = (value) => {
        setSearchResult(0)
        setLoading(true)
        return tlh.getIppnData(idToken, value).then(data => {
            data = data.body ? data.body : data
            const descompressData = decompressResponse(data)
            if (checkHasData(descompressData.total)) {
                setSearchResult(descompressData.total)
                if (descompressData.total === 1) {
                    setIppnResult(descompressData)
                    setValidId(descompressData.valid)
                    setValueData(descompressData.ippn)
                } else {
                    setSearchIppnResults(descompressData.ippns)
                }
            } else {
                setIppnResult([])
                setValidId(null)
                setValueData([])
                setSearchIppnResults([])
            }
            setLoading(false)
        }).catch(error => {
            if (error.message.indexOf("503") > 1) {
                toast(t('tlh.refineSearch'))
            } else {
                noData()
            }
            setLoading(false)
        })
    }

    // const getValidSearchData = (value) => {
    //     setSearchResult(0)
    //     // setLoading(true)
    //     return tlh.getValidData(idToken, value).then(data => {
    //         data = data.body ? data.body : data
    //         const descompressData = decompressResponse(data)
    //         console.log(descompressData)
    //         if (checkHasData(descompressData.total)) {
    //             setSearchResult(descompressData.total)
    //             if (descompressData.total === 1) {
    //                 setIppnResult(descompressData)
    //             } else {
    //                 setSearchIppnResults(descompressData.ippns)
    //                 console.log(ippnResult)
    //             }
    //         }
    //         setLoading(false)
    //     }).catch(error => {
    //         if (error.message.indexOf("503") > 1) {
    //             toast(t('tlh.refineSearch'))
    //             setLoading(false)
    //         }
    //     })
    // }

    const getSotSearchData = (value) => {
        setSearchResult(0)
        setLoading(true)
        return tlh.getSotData(idToken, value).then(data => {
            data = data.body ? data.body : data
            const descompressData = decompressResponse(data)
            console.log(descompressData)
            if (checkHasData(descompressData.total)) {
                setSearchResult(descompressData.total)
                if (descompressData.total === 1) {
                    setValueData(descompressData.sot)
                    setSotResult(descompressData)
                } else {
                    setSearchSotResults(descompressData.sots)
                }
            } else {
                setSotResult([])
                setValueData([])
                setSearchSotResults([])
            }
            setLoading(false)
        }).catch(error => {
            if (error.message.indexOf("503") > 1) {
                toast(t('tlh.refineSearch'))
            } else {
                noData()
            }
            setLoading(false)
        })
    }

    // const getClient = () => {
    //     setLoading(true)
    //     return tlh.getClient(idToken).then(data => {
    //         data = data.body ? data.body : data
    //         const descompressData = decompressResponse(data)
    //         if (descompressData) {
    //             setClient(descompressData)
    //         }
    //         setLoading(false)
    //     }).catch(error => {
    //         if (error.message.indexOf("503") > 1) {
    //             toast(t('tlh.refineSearch'))
    //         } else {
    //             noData()
    //         }
    //         setLoading(false)
    //     })
    // }


    // const getDocument = (value, type, idToken) => {
    //     setSearchResult(0)
    //     setLoading(true)
    //     return tlh.downloadDocument(idToken, type,value)
    //         .then(response => {
    //             // openDocument( response.data, type)
    //             return response
    //         })
    //         .catch(error => {
    //         console.log(error)
    //     })
    // }
    // const getDocumentDownloadURL = (value) => {
    //     setSearchResult(0)
    //     setLoading(true)
    //     return tlh.getDocumentDownloadURL(idToken, value).then(data => {
    //        return data = data.body ? data.body : data
    //     }).catch(error => {
    //         console.log(error)
    //     })
    // }

    // const openDocument =  (response, fileName) => {
    //     const link = document.createElement('a')
    //     link.href = response
    //     link.target = '_blank'
    //     link.download = fileName
    //     link.click()
    // }

    return (
        <TubularContext.Provider value={{
            isLoading,
            searchResult,
            valueData,
            setValueData,
            searchValue,
            setSearchValue,
            setSearchResult,
            setIppnResult,
            invoiceResult,
            sotResult,
            ippnResult,
            searchIppnResults,
            searchInvoiceResults,
            searchSotResults,
            purchaseOrderResult,
            searchPurchaseOrderResults,
            setSearchIppnResults,
            customersId,
            setCustomersId,
            getInvoiceSearchData,
            getPurchaseOrderSearchData,
            getIppnSearchData,
            getSotSearchData,
            // getValidSearchData,
            sotId,
            purchaseId,
            setPurchaseId,
            setSotId,
            setIppnId,
            setValidId,
            ippnId,
            validId,
            invoiceId,
            setInvoiceId,
            setReservationId,
            reservationId,
            getReservationSearchData,
            reservationResult,
            searchReservationResults,
            salesOrderResult,
            setSalesOrderResult,
            searchSalesOrderResults,
            setSearchSalesOrderResults,
            getSalesOrderSearchData,
            // getClient, client

        }}>
            {children}
        </TubularContext.Provider>
    )
}
